<template>
  <div class="pager-wrapper flex align-center" ref="pager">
    <div class="flex justify-start align-center font-12-85">
      当前第{{ pageNo }}页{{ pageTotal }}条，共{{ total }}条记录
    </div>
    <div style="margin-left:20px;width:100px">
      <el-select v-model="currentPageSizes" placeholder="" @change="changePagin">
        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
    </div>
    <div class="flex flex-1 justify-end">
      <div class="pager-box">
        <a class="pager-prev" :class="{ 'pager-disabled': firstDisable }" href="javascript:;" @click="jumpFirst()">首页</a>
        <a class="pager-prev" :class="{ 'pager-disabled': prevDisable }" href="javascript:;" @click="jumpPrev()">上一页</a>
        <div v-for="i in pageSize" :key="i">
          <span v-if="i == pageNo" class="pager-curr"><em class="pager-em"></em><em>{{ i }}</em></span>
          <a v-else-if="pageNo < 5 && (i) < 6" href="javascript:;" @click="jump(i)">
            {{ i }}
          </a>
          <a v-else-if="pageSize < 7 || i == 1 || i == pageSize || (pageNo - 2 <= i && i <= pageNo + 2)"
            href="javascript:;" @click="jump(i)">
            {{ i }}
          </a>
          <template v-else>
            <span v-if="pageNo < 5 && i == 6" class="pager-spr">…</span>
            <span v-if="pageNo == 4 && i == 7" class="pager-spr">…</span>
            <span v-if="pageNo > 4 && i == pageNo - 3" class="pager-spr">…</span>
            <span v-if="pageNo > 4 && i == pageNo + 3" class="pager-spr">…</span>
          </template>
        </div>
        <a class="pager-next" :class="{ 'pager-disabled': nextDisable }" href="javascript:;" @click="jumpNext()">下一页</a>
        <a class="pager-next" :class="{ 'pager-disabled': endDisable }" href="javascript:;" @click="jumpEnd()">尾页</a>
      </div>
      <div class="pager-input" style="margin-left: 18px">
        <a>跳至</a>
        <input type="text" v-model="jumpPage">
        <a>页</a>
        <a class="pager-btn-go" style="color: #ffffff;" href="javascript:;" @click="Go()">Go</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'pagination',
  model: { // 通过v-model传过来的参数
    prop: 'pageNo',
    event: 'jumpPage'
  },
  props: {
    pageSize: {
      type: Number,
      default: 1
    },
    pageNo: {
      type: Number,
      default: 1
    },
    pageTotal: {
      type: Number,
      default: 25
    },
    total: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      jumpPage: '', // 避免操作props参数
      options: [
        {
          label: '25条/页',
          value: '25'
        }, {
          label: '50条/页',
          value: '50'
        }, {
          label: '75条/页',
          value: '75'
        }, {
          label: '100条/页',
          value: '100'
        }, {
          label: '200条/页',
          value: '200'
        }],
      currentTotal: (this.pageTotal ? this.pageTotal : 25),
      currentPageSizes: (this.pageTotal ? this.pageTotal : 25) + '条/页'
    }
  },
  computed: {
    firstDisable: function () {
      if (this.pageNo > 1) {
        return false
      } else {
        return true
      }
    },
    prevDisable: function () { // “上一页”按钮是否可点
      if (this.pageNo > 1) {
        return false
      } else {
        return true
      }
    },
    nextDisable: function () { // “下一页”按钮是否可点
      if (this.pageNo < this.pageSize && this.pageSize > 1) {
        return false
      } else {
        return true
      }
    },
    endDisable: function () {
      if (this.pageNo < this.pageSize && this.pageSize > 1) {
        return false
      } else {
        return true
      }
    }
  },
  methods: {
    changePagin: function (e) {
      this.currentTotal = e
      let obj = {
        pageNo: 1,
        pageTotal: this.currentTotal
      }
      // this.$emit('jumpPage', this.pageNo)
      this.$emit('on-jump', obj)
    },
    jumpFirst: function () {
      if (this.pageNo === 1) {

      } else {
        let obj = {
          pageNo: 1,
          pageTotal: this.currentTotal
        }
        // this.$emit('jumpPage', this.pageNo = 1)
        this.$emit('on-jump', obj)
      }
    },
    jumpPrev: function () { // 点击上一页
      if (this.pageNo === 1) {

      } else {
        let obj = {
          pageNo: this.pageNo - 1,
          pageTotal: this.currentTotal
        }
        // this.$emit('jumpPage', this.pageNo - 1)
        this.$emit('on-jump', obj)
      }
    },
    jumpNext: function () { // 点击下一页
      if (this.pageNo === this.pageSize) {

      } else {
        let obj = {
          pageNo: this.pageNo + 1,
          pageTotal: this.currentTotal
        }
        // this.$emit('jumpPage', this.pageNo + 1) // 修改当前页码
        this.$emit('on-jump', obj) // 跳转
      }
    },
    jumpEnd: function () { // 尾页
      if (this.pageNo === this.pageSize) {

      } else {
        let obj = {
          pageNo: this.pageSize,
          pageTotal: this.currentTotal
        }
        // this.$emit('jumpPage', this.pageNo = this.pageSize) // 修改当前页码
        this.$emit('on-jump', obj) // 跳转
      }
    },
    jump: function (id) { // 直接跳转
      if (id > this.pageSize) {
        id = this.pageSize
      }
      this.jumpPage = ''
      let obj = {
        pageNo: id,
        pageTotal: this.currentTotal
      }
      // this.$emit('jumpPage', id) // 修改当前页码
      this.$emit('on-jump', obj) // 跳转
    },
    Go: function () {
      if (this.jumpPage === '') { // 判空处理

      } else if (/^\d*$/.test(parseInt(this.jumpPage))) { // 填写数字才能跳转
        this.jump(parseInt(this.jumpPage))
        this.jumpPage = ''
      } else {
        this.jumpPage = ''
      }
    }
  }
}
</script>

<style  scoped>
.pager-wrapper {
  position: relative;
  display: flex;
  /*justify-content: center;*/
}

.pager-box {
  text-align: center;
  display: flex;
}

.pager-box .pager-curr em {
  font-style: normal;
}

.pager-btn-go {
  display: inline-block;
  vertical-align: middle;
  height: 24px;
  line-height: 24px;
  margin: 5px;
  background-color: #46b8b0;
  padding: 0 10px;
  font-size: 12px;
  color: #ffffff;
  text-decoration: none;
  border: 1px solid #dce0e7;
  border-radius: 3px;
  box-sizing: content-box;
}

.pager-box a,
.pager-box span {
  display: inline-block;
  vertical-align: middle;
  height: 24px;
  line-height: 24px;
  margin: 5px;
  background-color: #fff;
  padding: 0 10px;
  font-size: 12px;
  color: #272727;
  text-decoration: none;
  border: 1px solid #dce0e7;
  border-radius: 3px;
  box-sizing: content-box;
}

.pager-input a {
  display: inline-block;
  vertical-align: middle;
  height: 24px;
  line-height: 24px;
  margin: 5px;
  font-size: 12px;
  color: #272727;
  text-decoration: none;
  border-radius: 3px;
  box-sizing: content-box;
}

.pager-box .pager-curr {
  position: relative;
}

.pager-box .pager-curr .pager-em {
  position: absolute;
  left: 0;
  top: 0;
  padding: 1px;
  width: 100%;
  height: 100%;
  background-color: #46b8b0;
  border-radius: 3px;
}

.pager-box .pager-curr em {
  position: relative;
  color: #ffffff;
}

/*.pager-box .pager-disabled{*/
/*background-color: #46b8b0;*/
/*color: #ffffff;*/
/*}*/
.pager-input {
  display: flex;
  align-items: center;
}

.pager-input input {
  width: 40px;
  height: 24px;
  line-height: 22px;
  border: 1px solid #dce0e7;
  box-sizing: border-box;
  padding: 0 5px;
  border-radius: 3px;
  text-align: center;
  margin: 0 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pagination.vue